import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import MetaSeo from '../MetaSeo';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { getAllCategory, getPosts } from '../../redux/actions/news';
import useTrans from '../../hooks/useTrans';
import { getListPostHot, getListPostNew } from '../../redux/actions/news';
import { useRouter } from 'next/router';
import Router from 'next/router';

export default function News(props) {
  const [rows, setRows] = useState(props.rows || []);
  const [total, setTotal] = useState(props.total || 0);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(3);
  const [category_name, setCategoryName] = useState('');
  const [list_new, setListNew] = useState([]);
  const [list_new_post, setListNewPost] = useState([]);
  const [total_new_post, setTotalNewPost] = useState();
  const router = useRouter();
  const dispatch = useDispatch();
  const trans = useTrans();
  const submitSearch = async event => {
    event.preventDefault();
    const data = await getPosts(
      { name: search?.trim(), page: 1, category: category_name },
      dispatch,
    );
    setPage(1);
    setTotal(data.total);
    setRows(data.rows);
  };
  const closeCategory = async () => {
    setCategoryName('');
    const data = await getPosts(
      { name: search?.trim(), page: 1, category: '' },
      dispatch,
    );
    setPage(1);
    setTotal(data.total);
    setRows(data.rows);
  };
  const onEnterkey = e => {
    if (e.key === 'Enter') {
      submitSearch();
    }
  };
  const { category } = useSelector(state => {
    return {
      category: state.news.category,
    };
  }, shallowEqual);
  const getNewHot = async locale => {
    const data = await getListPostHot({ sign: locale });
    setListNew(data);
  };
  const getPostNew = async locale => {
    const data = await getListPostNew({ sign: locale });
    if (data) {
      setListNewPost(data.rows);
      setTotalNewPost(data.total);
    }
  };

  useEffect(() => {
    // getListProjectFeatureHome(router.locale);
    // getListJobSlide();
    getNewHot(router.locale);
    getPostNew(router.locale);
  }, [router.locale]);
  useEffect(() => {
    setRows(props.rows);
    setTotal(props.total);
    setCategoryName('');
    setPage(3);
    getAllCategory({}, dispatch);
  }, [dispatch, props]);
  // const stripHtml = (html) => {
  //     let tmp = document.createElement('p');
  //     tmp.innerHTML = html;
  //     return tmp.textContent || tmp.innerText || '';

  // };
  const loadMore = async () => {
    let new_page = parseInt(page) + 1;
    setPage(new_page);
    const data = await getPosts(
      {
        page: new_page,
        limit: 3,
        name: search?.trim(),
        category: category_name,
      },
      dispatch,
    );
    if (data) {
      const new_data = [...rows, ...data.rows];
      setRows(new_data);
    }
  };
  const getPostByCategory = async name => {
    const data = await getPosts(
      { category: name, name: search?.trim() },
      dispatch,
    );
    setCategoryName(name);
    if (data) {
      setRows(data.rows);
      setTotal(data.total);
    }
  };
  const filterTag = async tag_name => {
    let new_search = `#${tag_name}`;
    setSearch(new_search);
    const data = await getPosts({ name: new_search, page: 1 }, dispatch);
    setPage(1);
    setTotal(data.total);
    setRows(data.rows);
  };

  // if (list_new.length < 3) {
  //   return null;
  // }
  const list_small1 = list_new.slice(0, 1) || [{}];
  const list_small2 = list_new.slice(1, 3) || [{}, {}];

  const dataSeo = {
    title: 'Tin tức | TCOM Corporation',
    description:
      'Những tin tức, sự kiện nổi bật về hoạt động hợp tác kinh doanh, cũng như các hoạt động nội bộ của TCOM.',
  };
  const dataSeoEN = {
    title: 'News | TCOM Corporation',
    description:
      'Technology news, outstanding events, business cooperation activities, as well as internal activities of TCOM',
  };

  return (
    <>
      {trans.seoVN ? <MetaSeo {...dataSeo} /> : <MetaSeo {...dataSeoEN} />}

      <div className='main-content'>
        <div className='r-featured-news'>
          <div className='container'>
            <div className='title'>
              <h3>{trans.news.title_featured}</h3>
              <div
                dangerouslySetInnerHTML={{
                  __html: trans.news.featured_description,
                }}
              ></div>
            </div>
            <div className='content'>
              <div className='row'>
                {list_small1.length > 0
                  ? list_small1.map((item, index) => {
                      return (
                        <div className='col-12 col-md-8 col-left'>
                          <Link href={`/news/${item.seo_url}`}>
                            <img className='img-fluid' src={item.image} />
                          </Link>
                          <Link href={`/${props.sign}/news/${item.seo_url}`}>
                            <a className='desc-img'>{item?.title}</a>
                          </Link>
                        </div>
                      );
                    })
                  : null}
                <div className='col-12 col-md-4 col-right'>
                  <div className='row'>
                    {list_small2.length > 0
                      ? list_small2.map((item, index) => {
                          return (
                            <div className='col-12 custom-padding'>
                              <Link href={`/news/${item.seo_url}`}>
                                <img className='img-fluid' src={item.image} />
                              </Link>
                              <Link
                                href={`/${props.sign}/news/${item.seo_url}`}
                              >
                                <a className='desc-img'>{item?.title}</a>
                              </Link>
                            </div>
                          );
                        })
                      : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='r-top'>
          <div className='container'>
            <div className='row'>
              <div className='col-12 col-md-7'>
                <div className='title-left'>
                  <h3>{trans.news.title}</h3>
                  {category_name ? (
                    <div className='handleBtnClose'>
                      <a
                        onClick={() => {
                          closeCategory();
                        }}
                      >
                        {category_name}
                      </a>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className='col-12 col-md-5'>
                <div className='search'>
                  <form>
                    <input
                      type='text'
                      placeholder={trans.seoVN ? 'Tìm kiếm' : 'Search'}
                      value={search}
                      onChange={e => setSearch(e.target.value)}
                    />
                    <button onClick={submitSearch}>
                      <svg
                        width={24}
                        height={24}
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z'
                          stroke='#A7A7A7'
                          strokeWidth={2}
                          strokeLinecap='round'
                        />
                      </svg>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='r-news-list'>
          <div className='container'>
            {rows.length > 0 ? (
              rows.map((item, index) => {
                return (
                  <div className='news-item'>
                    <div className='row'>
                      <div className='col-12 col-md-5'>
                        <Link
                          href={`/news/${item.seo_url}`}
                          className='image d-block'
                        >
                          <img
                            className='img-new'
                            src={item.image}
                            style={{
                              maxHeight: 258,
                              borderRadius: 15,
                              width: 445,
                              maxWidth: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                            alt={item.description}
                          />
                        </Link>
                      </div>
                      <div className='col-12 col-md-7'>
                        <div className='content'>
                          <a
                            onClick={() =>
                              getPostByCategory(item?.postcategory?.name)
                            }
                            className='category'
                          >
                            {item?.postcategory?.name}
                          </a>
                          <Link href={`/${props.sign}/news/${item.seo_url}`}>
                            <a className='title'>{item?.title}</a>
                          </Link>
                          <div className='date'>
                            {moment(item?.show_date || item?.createdAt).format(
                              'DD/MM/YYYY',
                            )}
                          </div>
                          <p className='content-news'>{item?.html_content}</p>
                          {/* <p className='desc'>{item.seo_description}</p> */}
                          <ul className='tag'>
                            {item.tag
                              ? item.tag.map((tag, index) => {
                                  return (
                                    <li key={index}>
                                      <a
                                        onClick={() => filterTag(tag.tag.name)}
                                      >
                                        {tag.tag.name}
                                      </a>
                                    </li>
                                  );
                                })
                              : null}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div id='not-found'>
                <div className='main-content'>
                  <div className='container'>
                    <div className='inner'>
                      <div className='image'>
                        <img src='/assets/images/404-search.png' alt='' />
                      </div>
                      <h3>{trans.project.no_result}</h3>
                      <Link href='/'>
                        <a className='btn-back'>{trans.project.back_home}</a>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {rows.length < total ? (
              <div className='text-center'>
                <a onClick={() => loadMore()} className='see-more'>
                  XEM THÊM
                </a>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}
